<!-- Start Containerbar -->
<div id="containerbar" class="containerbar authenticate-bg">
    <!-- Start Container -->
    <div class="container">
      <div class="auth-box login-box">
        <!-- Start row -->
        <div class="row no-gutters align-items-center justify-content-center">
          <!-- Start col -->
          <div class="col-md-6 col-offset-md-3">
            <!-- Start Auth Box -->
            <div class="auth-box-right">
              <div class="card">
                <div class="card-body">
                  <form
                    class="login-form"
                    [formGroup]="loginForm"
                    (ngSubmit)="onLogin()"
                  >
                    <div class="form-head">
                      <a class="logo"
                        ><img
                          src="assets/images/logo.svg"
                          class="img-fluid"
                          alt="logo"
                      /></a>
                    </div>
                    <h4 class="text-primary my-4">Login</h4>
                    <!-- <input id="licence" type="hidden" value="" /> -->
  
                    <div class="form-group" *ngIf="!hideInputField">
                      <input
                        type="text"
                        autofocus="autofocus"
                        class="form-control"
                        id="username"
                        placeholder="Enter Email"
                        required
                        formControlName="email"
                        oninput="this.value = this.value.toLowerCase();"
                        autocomplete="off"
                        [ngClass]="{
                          'is-invalid': submitted && f.email.errors
                        }"
                      />
                      <div
                        *ngIf="submitted && f.email.errors"
                        class="invalid-feedback"
                      >
                        <div *ngIf="f.email.errors.email">
                          Please enter valid email address
                        </div>
                        <div *ngIf="f.email.errors.required">
                          Please enter email address
                        </div>
                      </div>
                    </div>
  
                    <div class="row pt-3">
                      <div class="col-md-4"></div>
                      <div class="col-md-4" *ngIf="!hideInputField">
                        <button
                          type="submit"
                          class="btn btn-primary-rgba btn-lg btn-block font-18"
                          [disabled]="disableBtn"
                        >
                          Submit
                        </button>
                      </div>
                      <div class="col-md-4"></div>
                    </div>
                  </form>
                  <p-progressSpinner
                    *ngIf="loading"
                    [style]="{ width: '30px', height: '50px' }"
                    styleClass="custom-spinner"
                    strokeWidth="8"
                  ></p-progressSpinner>
                </div>
                <!-- This is the magic login link that will be clicked -->
              </div>
            </div>
            <!-- End Auth Box -->
          </div>
          <!-- End col -->
        </div>
        <!-- End row -->
      </div>
    </div>
    <!-- End Container -->
  </div>
  <!-- End Containerbar -->
  <p-toast preventOpenDuplicates="false"></p-toast>
  